import { useRef } from 'react'
import { cn } from '@/lib/utils'
import type { DiffOverviewMarker } from '@/lib/diff-overview-markers'
import { DiffOverviewRuler } from '@/components/features/diff-overview-ruler'
import { testIds } from '@/lib/test-ids'

export interface DiffScrollPaneProps {
  markers: DiffOverviewMarker[]
  children: React.ReactNode
  className?: string
}

/** Scroll container with a diff overview ruler on the right edge. */
export function DiffScrollPane({ markers, children, className }: DiffScrollPaneProps) {
  const scrollRef = useRef<HTMLDivElement>(null)

  return (
    <div
      className={cn('relative h-full min-h-[280px]', className)}
      data-testid={testIds.diffOverview.scrollPane}
    >
      <div
        ref={scrollRef}
        className="absolute inset-0 overflow-y-auto overflow-x-hidden pr-3.5"
      >
        {children}
      </div>
      <DiffOverviewRuler scrollRef={scrollRef} markers={markers} />
    </div>
  )
}
